import React from 'react'
import styled from 'styled-components'

import Icon from '../Icon'
import Tooltip from '../Tooltip'
import TransitionMantineTooltip from '../TransitionMantineTooltip'

const Wrapper = styled.div`
  cursor: pointer;
  padding: 10px 10px 5px 10px;
  // width: 35px;
`

type TCloser = {
  onClick?: () => void
  setIsHovered?: (val: boolean) => void
  tooltip?: string
  isHovered?: boolean
  closerIcon?: string
}

const Closer = (props: TCloser): React.ReactElement => {
  const { onClick, setIsHovered, tooltip, closerIcon, isHovered } = props

  const onMouseOver = (): void => {
    if (setIsHovered) {
      setIsHovered(true)
    }
  }

  const onMouseOut = (): void => {
    if (setIsHovered) {
      setIsHovered(false)
    }
  }

  return (
    <TransitionMantineTooltip tooltip={tooltip}>
      <Wrapper
        onMouseOver={onMouseOver}
        onFocus={onMouseOver}
        onMouseOut={onMouseOut}
        onBlur={onMouseOut}
        onClick={onClick}
      >
        <Icon icon={closerIcon || 'fal fa-times'} />
      </Wrapper>
    </TransitionMantineTooltip>
  )
}

export default Closer
